import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { LOCALES, DEFAULT_LOCALE } from 'constants/app-config'
import { createPath } from 'history'
import { SET_I18N } from 'modules/App/types'
import { selectAppLocale } from 'modules/App/store/selectors'

const browserLang = navigator.language || navigator.userLanguage

const PathSwitcher = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const i18n = useSelector(selectAppLocale)

  let defaultLang = LOCALES.includes(browserLang) ? browserLang : DEFAULT_LOCALE

  useEffect(() => {
    const reg = new RegExp(`^(\\/)(${LOCALES.join('|')})(\\/)`)

    const parsedLang = global.location.pathname.match(reg)?.[2] || defaultLang

    dispatch({
      type: SET_I18N,
      payload: {
        i18n: LOCALES.includes(parsedLang)
          ? parsedLang
          : process.env.REACT_APP_DEFAULT_LOCALE,
      },
    })
  }, [])

  useEffect(() => {
    const reg = new RegExp(`^\\/[${LOCALES.join('|')}]{2}\\/`)
    history.replace(
      createPath({
        pathname: global.location.pathname.replace(reg, '/' + i18n + '/'),
        search: global.location.search,
      }),
    )
  }, [i18n])

  return null
}

export default PathSwitcher
